import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useCarCheckoutDateRange } from "@tenant/cars";
import clsx from "clsx";
import styles from "./CarCheckoutPickupDropoff.module.scss";

interface CarCheckoutPickupDropoffProps extends PlatformComponentProps {
  titles?: {
    pickupTitle?: string;
    dropoffTitle?: string;
  };
  addresses: {
    pickupAddress: string;
    dropoffAddress: string;
  };
  dateRange: { pickupDate: string; dropoffDate: string };
}

export const CarCheckoutPickupDropoff = ({
  className,
  titles,
  addresses,
  dateRange,
}: CarCheckoutPickupDropoffProps) => {
  const [block, cn] = useModuleBEM(styles, "CarCheckoutPickupDropoff");
  const { t } = useI18nContext();

  const { pickupDateAndTime, dropoffDateAndTime } = useCarCheckoutDateRange({
    pickupTime: dateRange.pickupDate,
    dropoffTime: dateRange.dropoffDate,
  });

  return (
    <div className={clsx(block, className)}>
      <div className={cn("location", ["pickup-location"])}>
        <span className={cn("title")}>
          {titles?.pickupTitle ?? t("checkout.cars.locationCard.pickupTitle")}
        </span>
        <span className={cn("time")}>
          {t("core-cars.locationCard.pickupTime", {
            date: pickupDateAndTime.date,
            time: pickupDateAndTime.time,
          })}
        </span>
        <span className={cn("address")}>{addresses.pickupAddress}</span>
      </div>

      <div className={cn("location", ["dropoff-location"])}>
        <span className={cn("title")}>
          {titles?.dropoffTitle ?? t("checkout.cars.locationCard.dropoffTitle")}
        </span>
        <span className={cn("time")}>
          {t("core-cars.locationCard.dropoffTime", {
            date: dropoffDateAndTime.date,
            time: dropoffDateAndTime.time,
          })}
        </span>
        <span className={cn("address")}>{addresses.dropoffAddress}</span>
      </div>
    </div>
  );
};
